import Box from "@mui/material/Box";
import "../SorintTools.scss";
import Tooltip from "@mui/material/Tooltip";

const Item = ({ toolName, toolTooltip, srcicon, srciconcolored, area }) => {
  return (
    <Tooltip data-testid="tooltip" title={toolTooltip ? toolTooltip : "title"}>
      <Box className="main-grid">
        <Box className="tool-grid">
          <Box className="box-img" id={`srcicon${toolName}`}>
            <img src={srciconcolored} alt={toolName} className="srciconcolored" />
            <img src={srcicon} alt={toolName} className="srcicon" />
          </Box>
          <Box>
            <h4>{toolName}</h4>
          </Box>
        </Box>

        <Box className="grid-group section-desktop">
          <h5 style={{ textTransform: "uppercase", fontWeight: 600 }}>{area}</h5>
        </Box>
      </Box>
    </Tooltip>
  );
};

export default Item;
